import updateRideFare from '../../../../actions/siteadmin/RideFare/updateRideFare';

async function submit(values, dispatch) {
    await dispatch(updateRideFare(values));
}

export default submit;
